import {
    type SwitchOrganizationResponseType,
    type SwitchOrganizationRequestType
} from "./type";
import {
    request
} from "../request";

const SwitchOrganization = async (params: SwitchOrganizationRequestType): Promise<SwitchOrganizationResponseType> => {
    return await request<SwitchOrganizationResponseType>("/users/switch-organization", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default SwitchOrganization;
